﻿import React, { Fragment } from 'react';
import PropTypes from 'prop-types';
import { Button } from "components/buttons";
import { Spinner } from "@blueprintjs/core";
import { ShowHide } from 'components/layout';

import './Buttons.css';

export function ButtonSave(
    {
        id = null,
        loading = false,
        disabled = false,
        simpleDisabled = false,
        text = "Save",
        icon = "floppy-disk",
        intent = "save",
        minimal = false,
        iconOnly = false,
        large = true,
        onClick
    }
) {
   
    return (
        <Fragment>
            <Button
                loading={loading}
                text={text}
                icon={icon}
                intent={intent}
                onClick={onClick}
                disabled={disabled || simpleDisabled}
                id={id}
                minimal={minimal}
                iconOnly={iconOnly}
                large={large}
            ></Button>
            <ShowHide
                evaluator={disabled}
                show={(
                    <div className="save-loader">
                        <Spinner size="25" />
                    </div>
                )}
            >
                    
            </ShowHide>
        </Fragment>
    );

}

ButtonSave.propTypes = {
    id: PropTypes.string,
    loading: PropTypes.bool,
    onClick: PropTypes.func.isRequired,
    disabled: PropTypes.bool,
    text: PropTypes.string,
    icon: PropTypes.string,
    simpleDisabled: PropTypes.bool,
    intent: PropTypes.string,
    minimal: PropTypes.bool,
    iconOnly: PropTypes.bool,
    large: PropTypes.bool
};